export default __webpack_public_path__ + "static/media/GSRR_6.d9ef49eb.svg";